<template>
  <div>
    <div class="d-flex">
      <div
        :class="['level-strength-pswd',
                 { 'active' : password_checker_lv1 || password_checker_lv2 ||
        password_checker_lv3 || password_checker_lv4 || password_checker_lv5 }]" />
      <div
        :class="['level-strength-pswd',
                 { 'active' :
                   (password_checker_lv1 && password_checker_lv2) ||
                   (password_checker_lv1 && password_checker_lv3) ||
                   (password_checker_lv1 && password_checker_lv4) ||
                   (password_checker_lv1 && password_checker_lv5) ||
                   (password_checker_lv2 && password_checker_lv3) ||
                   (password_checker_lv2 && password_checker_lv4) ||
                   (password_checker_lv2 && password_checker_lv5) ||
                   (password_checker_lv3 && password_checker_lv4) ||
                   (password_checker_lv3 && password_checker_lv5) ||
      (password_checker_lv4 && password_checker_lv5) }]" />
      <div
        :class="['level-strength-pswd',
                 { 'active' :
                   (password_checker_lv1 && password_checker_lv2 &&
                   password_checker_lv3)||
                   (password_checker_lv1 && password_checker_lv2 && password_checker_lv4) ||
                   (password_checker_lv1 && password_checker_lv2 && password_checker_lv5) ||
                   (password_checker_lv1 && password_checker_lv3 && password_checker_lv4) ||
                   (password_checker_lv1 && password_checker_lv3 && password_checker_lv5) ||
                   (password_checker_lv2 && password_checker_lv3 && password_checker_lv4) ||
      (password_checker_lv2 && password_checker_lv3 && password_checker_lv5)}]" />
      <div
        :class="['level-strength-pswd',
                 { 'active':
                   (password_checker_lv1 && password_checker_lv2 &&
                   password_checker_lv3 && password_checker_lv4) ||
                   (password_checker_lv1 && password_checker_lv2 &&
        password_checker_lv3 && password_checker_lv5) }]" />
      <div
        :class="['level-strength-pswd',
                 { 'active' :
                   password_checker_lv1 && password_checker_lv2 &&
        password_checker_lv3 && password_checker_lv4 && password_checker_lv5 }]" />
    </div>
    <div v-show="new_password">
      <div class="level-strength-label">
        <img
          :src="require(`@/assets/icon/${password_checker_lv1 ? 'checked-green' : 'error' }.png`)"
          width="15">
        Minimum 8 characters
      </div>
      <div class="level-strength-label">
        <img
          :src="require(`@/assets/icon/${password_checker_lv2 ? 'checked-green' : 'error' }.png`)"
          width="15">
        At least one capital letter
      </div>
      <div class="level-strength-label">
        <img
          :src="require(`@/assets/icon/${password_checker_lv3 ? 'checked-green' : 'error' }.png`)"
          width="15">
        At least one number
      </div>
      <div class="level-strength-label">
        <img
          :src="require(`@/assets/icon/${password_checker_lv4 ? 'checked-green' : 'error' }.png`)"
          width="15">
        At least one special character
      </div>
      <div class="level-strength-label">
        <img
          :src="require(`@/assets/icon/${password_checker_lv5 ? 'checked-green' : 'error' }.png`)"
          width="15">
        Your password cannot contain your account name
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
      required: true,
    },
  },

  data() {
    return {
      new_password: '',
      email: '',
    };
  },

  computed: {
    password_checker_lv1() {
      if (this.new_password) {
        return this.new_password.length > 7;
      }
      return false;
    },
    password_checker_lv2() {
      return /[A-Z]/.test(this.new_password);
    },
    password_checker_lv3() {
      return /[0-9]/.test(this.new_password);
    },
    password_checker_lv4() {
      return /[*@!#%&()^~{}]/.test(this.new_password);
    },
    password_checker_lv5() {
      if (this.email && this.new_password) {
        const atPosition = this.email.indexOf('@');
        const regex = new RegExp(this.email.substring(0, atPosition), 'ig');
        return !regex.test(this.new_password);
      }
      return false;
    },
    checkPasswordStrengh() {
      return this.password_checker_lv1 && this.password_checker_lv2 &&
      this.password_checker_lv3 && this.password_checker_lv4 && this.password_checker_lv5;
    },
  },

  watch: {
    data: {
      handler(val) {
        this.new_password = val && val.password ? val.password : '';
        this.email = val && val.email ? val.email : '';
      },
      deep: true,
    },
  },

  created() {
    if (this.data) {
      this.new_password = this.data.password;
      this.email = this.data.email;
    }
  },

  methods: {

  },
};
</script>

<style lang="scss">
.level-strength-pswd {
  width: 25%;
  height: 4px;
  background: #EDEDED;
  margin: 2px;
}

.level-strength-pswd.active {
  background: #A9E1C6;
}

.level-strength-label {
  color: #808285;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/user-employee/partials/PasswordChecker.vue